import React from 'react'
import { Flex, TextVariant, Text, Tooltip } from '@mprolab/uikit'
import { Info } from 'react-feather'
import { useTheme } from 'styled-components'
import UseAnimations from 'react-useanimations'
import loadingAnimation from 'react-useanimations/lib/loading'
import isNil from 'lodash/isNil'

const EstimatedFeeDisplay = ({ fee, ticker, loading }) => {
  const { colors } = useTheme()

  return (
    <Flex
      fullWidth
      p="8px"
      borderRadius="8px"
      justifyContent="space-between"
      background={colors.gray10}
      alignItems="center"
    >
      <Flex gap="8px" alignItems="center">
        <Tooltip title="Total fee for your transaction">
          <Info color={colors.gray6} style={{ cursor: 'pointer' }} />
        </Tooltip>
        <Text variant={TextVariant.TEXT_XS_BOLD}>Est. Fee</Text>
      </Flex>
      {loading ? (
        <UseAnimations strokeColor={colors.white3} fillColor={colors.white3} animation={loadingAnimation} />
      ) : (
        <>
          {isNil(ticker) ? (
            <Text variant={TextVariant.TEXT_XS_BOLD}>-</Text>
          ) : (
            <Text variant={TextVariant.TEXT_XS_BOLD}>{`${fee} ${ticker}`}</Text>
          )}
        </>
      )}
    </Flex>
  )
}

export default EstimatedFeeDisplay
